import React from "react";
import { Mail, Phone, MapPin } from "lucide-react";
import { Card } from "./ui/card";
import { personalInfo } from "../mock";

const Contact = () => {
  return (
    <section
      id="contact"
      className="min-h-screen bg-gradient-to-b from-[#0a0a0a] via-[#0d0d1a] to-[#0a0a0a] py-32 px-6 flex items-center"
    >
      <div className="max-w-5xl mx-auto w-full text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 drop-shadow-[0_0_20px_rgba(59,130,246,0.3)]">
          Let’s Connect
        </h2>
        <p className="text-xl text-gray-400 mb-16">
          I’d love to hear from you — whether it’s a collaboration, a question, or just to say hi.
        </p>

        <div className="grid sm:grid-cols-3 gap-8">
          <Card className="bg-[#0f0f1a] border-blue-500/30 p-6 hover:border-blue-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(59,130,246,0.2)]">
            <div className="flex flex-col items-center text-center">
              <Mail className="w-8 h-8 text-blue-400 mb-4" />
              <p className="text-sm text-gray-400 mb-1">Email</p>
              <a
                href={`mailto:${personalInfo.email}`}
                className="text-white hover:text-blue-400 transition-colors"
              >
                {personalInfo.email}
              </a>
            </div>
          </Card>

          <Card className="bg-[#0f0f1a] border-cyan-500/30 p-6 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(6,182,212,0.2)]">
            <div className="flex flex-col items-center text-center">
              <Phone className="w-8 h-8 text-cyan-400 mb-4" />
              <p className="text-sm text-gray-400 mb-1">Phone</p>
              <a
                href={`tel:${personalInfo.phone}`}
                className="text-white hover:text-cyan-400 transition-colors"
              >
                {personalInfo.phone}
              </a>
            </div>
          </Card>

          <Card className="bg-[#0f0f1a] border-indigo-500/30 p-6 hover:border-indigo-500/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(99,102,241,0.2)]">
            <div className="flex flex-col items-center text-center">
              <MapPin className="w-8 h-8 text-indigo-400 mb-4" />
              <p className="text-sm text-gray-400 mb-1">Location</p>
              <p className="text-white">{personalInfo.location}</p>
            </div>
          </Card>
        </div>

        <p className="text-gray-500 text-sm mt-16">
          Or reach me directly on{" "}
          <a
            href="https://github.com/YOUR_GITHUB_USERNAME"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300"
          >
            GitHub
          </a>{" "}
          or{" "}
          <a
            href="https://www.linkedin.com/in/YOUR_LINKEDIN_USERNAME"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:text-blue-300"
          >
            LinkedIn
          </a>.
        </p>
      </div>
    </section>
  );
};

export default Contact;
